module.exports = "/_next/static/images/OgSegmentIndustryB2B-c1de4c1d895d763db7c8cd7762664ce8.png";